<script lang="ts">
  interface Props {
    size?: 16 | 20;
  }

  let { size = 16 }: Props = $props();
</script>

<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 25" fill="none">
  <g clip-path="url(#clip0_9338_8317)">
    <path
      d="M11.9929 6.21494H15.5637C15.8198 6.21494 15.9621 6.3572 15.9621 6.61328V8.51962C15.9621 8.77569 15.8198 8.91796 15.5637 8.91796H11.9929C11.1535 8.91796 10.5987 9.47279 10.5987 10.3121V12.9156H15.5495C15.8056 12.9156 15.9478 13.0579 15.9478 13.3139V15.2203C15.9478 15.4763 15.8056 15.6186 15.5495 15.6186H10.5987V19.3317C10.5987 19.5878 10.4564 19.7301 10.2004 19.7301H8.22288C7.9668 19.7301 7.82454 19.5878 7.82454 19.3317V10.3691C7.82454 7.89366 9.51749 6.21494 11.9929 6.21494Z"
      fill="#003824"
    />
    <path
      d="M11.9929 24.4959C9.81625 24.4959 7.66806 23.8699 5.80439 22.6749C3.49971 21.1811 1.82099 18.9049 1.06699 16.273C0.312987 13.6696 0.526383 10.8812 1.65027 8.42003C1.83522 8.02169 2.29046 7.85097 2.6888 8.03592C3.08714 8.22086 3.25786 8.67611 3.07292 9.07445C2.10552 11.1942 1.92057 13.5985 2.57499 15.8462C3.22941 18.1225 4.6805 20.0715 6.65798 21.3661C9.00534 22.8883 11.9218 23.3293 14.6248 22.5753C15.0374 22.4615 15.4784 22.7034 15.5922 23.1159C15.706 23.5285 15.4641 23.9695 15.0516 24.0833C14.0415 24.3679 13.0172 24.4959 11.9929 24.4959Z"
      fill="#007533"
    />
    <path
      d="M17.6977 22.8456C17.4416 22.8456 17.1855 22.7176 17.0433 22.49C16.8157 22.1201 16.9152 21.6364 17.2851 21.4088C18.4802 20.6548 19.4618 19.6589 20.2442 18.4781C23.1891 13.9399 21.8945 7.86519 17.3563 4.92032C17.214 4.82073 17.0433 4.72115 16.8441 4.60734C16.4742 4.39394 16.332 3.91024 16.5454 3.54036C16.7588 3.17047 17.2425 3.0282 17.6123 3.2416C17.84 3.36964 18.0249 3.48345 18.1956 3.59726C23.4594 7.01161 24.9532 14.0537 21.5388 19.3175C20.6426 20.6974 19.4902 21.8356 18.1103 22.7176C17.9822 22.803 17.84 22.8456 17.6977 22.8456Z"
      fill="#FFC200"
    />
    <path
      d="M4.06877 6.91203C3.88383 6.91203 3.69888 6.84089 3.55662 6.71286C3.22941 6.42833 3.20096 5.9304 3.48548 5.60319C6.21696 2.51606 10.428 1.13609 14.4683 2.04658C14.8951 2.14617 15.1512 2.55874 15.0658 2.98553C14.9662 3.41232 14.5537 3.6684 14.1269 3.58304C10.6414 2.80059 7.01364 3.98138 4.65205 6.65595C4.49556 6.82667 4.28217 6.91203 4.06877 6.91203Z"
      fill="#00DB33"
    />
  </g>
  <defs>
    <clipPath id="clip0_9338_8317">
      <rect width="24" height="24" fill="white" transform="translate(0 0.993835)" />
    </clipPath>
  </defs>
</svg>
